import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { Field, Formik } from 'formik';
import React, { useState,useEffect } from 'react';
import Calendar from 'assets/icon/calendar-icon.svg';
import { Button, Card, CardBody, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';


let hasDatePopupOpen = false;

const EditConfiguration = (props) => {
    const { searchTerms, refetch,manvalConfigedit, rowData,orgId} = props;
    console.log(rowData,"rowdata in edit")
    const [isChecked, setIsChecked] = useState(false);
     const API = useAxios();
     const [data,setData] = useState("");
     const [inputValue, setInputValue] = useState('');
     const [modal, setModal] = useState(false);
     const toggle = () => setModal(!modal);     
     const [ceName,setCEName] = useState("");
     const [opa,setOpa] = useState("");
     const [ceTypeID,setCeTypeID] = useState("");
     const [contactName,setcontactName] = useState("");
     const [address1,setAddress1] = useState("");
     const [address2,setAddress2] = useState("");
     const [zipCode,setZipCodeEName] = useState("");
     const [phone,setPhone] = useState("");
     const [ext,setExt] = useState("");
     const [fax,setFax] = useState("")
     const [emailID,setEmailId] = useState("")
     const [website,setWebsite] = useState("")
     const [tollFreeNo,setTollFreeNo] = useState("")
   //  const [coveredEntityList, SetCoveredEntityList] = useState([]);



const handleCEChange = (e) =>{
   setCEName(e.target.value)
   console.log(ceName,"ceNamechange")
}
 
// const handleOpaidChange = (e) =>{
//     setOpa(e.target.value)
//     console.log(opa,"cntactChange")
// }

const handleContactChange =(e)=>{
    setcontactName(e.target.value)
    console.log(contactName,"cntactChange")
}

const handleAddree1 = (e) =>{
    setAddress1(e.target.value)
    console.log(address1,"address1")
}

const handleAddress2 = (e) =>{
    setAddress2(e.target.value)
    console.log(address2,"Address2")
}

const handleZipCode = (e) =>{
    setZipCodeEName(e.target.value)
    console.log(zipCode,"zipcode")
}

const handlePhoneChange = (e)=>{
    setPhone(e.target.value)
    console.log(phone,"Phone")
}

const handleExtChange =(e)=>{
    setExt(e.target.value)
    console.log(ext,"ext")
}

const handleFaxChange =(e)=>{
    setFax(e.target.value)
    console.log(fax,"fax")
}

const handleEmailChange =(e)=>{
    setEmailId(e.target.value)
    console.log(emailID)
}

const handleWebsiteChange =(e)=>{
    setWebsite(e.target.value)
    console.log(website)
}

const handleTollFreeNo = (e) =>{
    setTollFreeNo(e.target.value)
    console.log(tollFreeNo)
}

const handleSubmit = async() =>{

    let CoveredEntityList=[]


    var lst = {};
 lst.coveredEntityName = ceName
 lst.OPACode = opa,
 lst.CoveredEntityTypeID = ceTypeID,
 lst.ContactName = contactName,
 lst.Address1 = address1
 lst.Address2 = address2
 lst.ZipCode = zipCode
 lst.Phone = phone,
 lst.Ext=ext
 lst.Fax = fax
 lst.EmailID = emailID
 lst.Website = website
 lst.TollFreeNo = tollFreeNo   

 console.log(lst,"Editlst")
 CoveredEntityList.push(lst)
 manvalConfigedit();
 try {
    // 
      const result = await API.post(

     `SBConfig/CoveredEntity/EditCoveredEntity`,{CoveredEntityList},
    {
    hasDefaultURL: true,
    hideLoader: true,
    }
    );
    toast.success('CoverEntity saved successfully');
    if (result) {
            
        setResultData(result.data);
        setHideRow(true);
        setShowResultRow(false);
        setLoading(false);
        manvalPharmacy()

        refetch();
    }
} catch (error) {
  console.log(error);
}


toggle();

}

    // const handleToggle = () => {
    //     setIsChecked(!isChecked);
    // };
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };
    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    useEffect(() => {
        fetchEditConfig();
      }, []);
    
      const fetchEditConfig = async () => {
        //    
        try {
          const { data } = await API.get(
            `SBConfig/CoveredEntity/GetCoveredEntityDetails/${rowData.coveredEntityID}`,
            {
              hasDefaultURL: true,
            }
          );
          if (data) {
            console.log(data,"rowdata");
            setData(data[0]);
          }
        } catch (err) {}
      };
      const handleClick = () => {
        manvalConfigedit();
      }

  return (      
    <div>
        <Container>
            <Card>
                <CardBody>
                <h4 className='f-15 text-primary font-weight-700'> Covered Entity Information </h4>
                <Formik
                            // initialValues={initialValues}
                            // onSubmit={handleSubmit}
                            // validationSchema={validationSchema}
                            // enableReinitialize={true}
                            children={(props) => {
                                // const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                                return (
                                    <div hidden={""}>
                                        <Row sm={5}>
                                        <Col md={4}  lg={3} sm={12} xs={12} >
                                {' '}
                                <FormGroup>
                                    <Label for='coveredentity'>Covered Entity</Label>
                                    <Input
                                        id='coveredentity'
                                        name='coveredentity'
                                        type='text'
                                        placeholder="Enter Covered Entity Name"
                                        autoComplete='off'
                                        //  value={ceName}
                                        component={""}
                                        defaultValue={data.ceName}
                                        onChange={handleCEChange}
                                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='opaid'>OPA ID</Label>
                                    <Input
                                        id='opaid'
                                        name='opaid'
                                        type='text'
                                        disabled
                                        placeholder="Enter OPA ID "
                                        autoComplete='off'
                                       defaultValue={data.opaCode}
                                        // value={""}
                                       // onChange={handleOpaidChange}
                                        component={""}
                                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}  lg={3} sm={12} xs={12} >
                                {' '}
                                <FormGroup>
                                    <Label for='Coveredentitytype'>Covered Entity Type</Label>
                                    <Input
                                        id='Coveredentitytype'
                                        name='Coveredentitytype'
                                        type='text'
                                        disabled
                                        placeholder="Enter Covered Entity Type "
                                        autoComplete='off'
                                        // value={""}
                                        component={""}
                                        defaultValue={data.coveredEntityType}
                                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}  lg={3}sm={12} xs={12} >
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Live Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <Field
                                                    type='text'
                                                    id='livedate'
                                                    name='livedate'
                                                    disabled
                                                    autoComplete='off'
                                                    placeholder='Select a date'
                                                    value={""}
                                                    component={FormikDatePicker}
                                                    onChange={""}
                                                />
                                                <InputGroupText
                                                    // onClick={() => handleDateClick('startDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </Row>
                            </Col>
                            <Col md={4}  lg={3}sm={12} xs={12} >
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Termination Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <Field
                                                    type='text'
                                                    id='terminationdate'
                                                    name='terminationdate'
                                                    disabled
                                                    autoComplete='off'
                                                    placeholder='Select a Termination Date'
                                                    value={""}
                                                    component={FormikDatePicker}
                                                    onChange={""}
                                                />
                                                <InputGroupText
                                                 onClick={() => handleDateClick('terminationdate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </Row>
                            </Col>
                            
                            {/* <Col md={4}  lg={3}sm={12} xs={12} >
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>HRSA Medicaid Billing : </Label>
                                            <div>
                                            <span className='m-0 f-14 font-weight-500 mt-1'>Yes</span>

                                            </div>

                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </Row>
                            </Col>
                            <Col md={4}  lg={3}sm={12} xs={12}>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                        <Label>GPO Prohibition : </Label>
                                          <div className="d-flex">
                                          <span className='m-0 f-14 font-weight-500 mt-1' style={{textAlign:"center"}}> {" "}No</span>

                                          </div>
                                            
                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </Row>
                            </Col>
                            <Col md={4}  lg={3}sm={12} xs={12}>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                        <Label> NDC to NDC Map : </Label>

                                            <div>
                                            <span className='label on m-0 f-14 font-weight-500 mt-1'> {" " }Yes</span>
                                            </div>

                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </Row>
                            </Col>
                            <Col md={4}  lg={3}sm={12} xs={12}>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>GCN Automapping : </Label>
                                            <div>
                                            <span className='label on m-0 f-14 font-weight-500 mt-1'>Yes</span>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </Row>
                            </Col>
                            <Col md={4}  lg={3}sm={12} xs={12}>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Payor Exclusions (Includes Out of State Medicaid) : </Label>
                                            <span className='label on m-0 f-14 font-weight-500 mt-1'>Yes</span>

                                        </FormGroup>
                                    </Col>
                                   
                                    
                                </Row>
                            </Col> */}
                                        </Row>
                                        
                                        <h4 className='f-15 text-primary font-weight-700 mt-3'>Address Information </h4>

                                        <Row sm={5}>
                                        <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Contactperson'>Contact Person</Label>
                                    <Input
                                        id='Contactperson'
                                        name='Contactperson'
                                        type='text'
                                        placeholder="Enter Contact Person Name"
                                        autoComplete='off'
                                        // value={""}
                                        defaultValue={data.contactName}
                                        component={""}
                                        onChange={handleContactChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Address1'>Address 1</Label>
                                    <Input
                                        id='Address1'
                                        name='Address1'
                                        type='text'
                                        placeholder="Enter Address"
                                        autoComplete='off'
                                       // value={data.address1}
                                       onChange={handleAddree1}
                                       defaultValue={data.address1}
                                        component={""}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Address1'>Address 2</Label>
                                    <Input
                                        id='Address'
                                        name='Address'
                                        type='text'
                                        placeholder="Enter Address"
                                        autoComplete='off'
                                        onChange={handleAddress2}
                                        // value={""}
                                        defaultValue={data.address2}
                                        component={""}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Zip Code'>Zip Code</Label>
                                    <Input
                                        id='zipcode'
                                        name='zipcode'
                                        type='text'
                                        placeholder="Enter Zip Code "
                                        autoComplete='off'
                                        onChange={handleZipCode}
                                        defaultValue={data.zipCode}
                                        // value={""}
                                        component={""}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='phoneno'>Phone</Label>
                                    <Input
                                        id='phoneno'
                                        name='phoneno'
                                        type='text'
                                        placeholder="Enter Phone "
                                        autoComplete='off'
                                        onChange={handlePhoneChange}
                                        // value={""}
                                        defaultValue={data.phone}
                                        component={""}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='ext'>Ext</Label>
                                    <Input
                                        id='ext'
                                        name='ext'
                                        type='text'
                                        placeholder="Enter Ext "
                                        autoComplete='off'
                                        // value={""}
                                        onChange={handleExtChange}
                                        component={""}
                                        defaultValue={data.ext}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='fax'>Fax</Label>
                                    <Input
                                        id='fax'
                                        name='fax'
                                        type='text'
                                        placeholder="Enter Fax No "
                                        autoComplete='off'
                                        onChange={handleFaxChange}
                                        // value={""}
                                        component={""}
                                        defaultValue={data.fax}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Email'>Email</Label>
                                    <Input
                                        id='Email'
                                        name='Email'
                                        type='text'
                                        placeholder="Enter Email Id "
                                        autoComplete='off'
                                        // value={""}
                                        onChange={handleEmailChange}
                                        defaultValue={data.emailID}
                                        component={""}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Website'>Website</Label>
                                    <Input
                                        id='website'
                                        name='website'
                                        type='text'
                                        placeholder="Enter Website"
                                        autoComplete='off'
                                        // value={""}
                                        onChange={handleWebsiteChange}
                                        defaultValue={data.website}
                                        component={""}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}  lg={3} sm={6} xs={6} >
                                {' '}
                                <FormGroup>
                                    <Label for='Toll Free No'>Toll Free No</Label>
                                    <Input
                                        id='Tollno'
                                        name='Tollno'
                                        type='text'
                                        placeholder="Enter Toll Free No"
                                        autoComplete='off'
                                        // value={""}
                                        onChange={handleTollFreeNo}
                                        defaultValue={data.tollFreeNo}
                                        component={""}
                                    />
                                </FormGroup>
                            </Col>             
                             </Row>
                                       
                           <Col className='pt-4 mt-1'>
                            <Label>{''}</Label>
                            <Button
                                style={{ float: 'right' }}
                                //disabled={isSubmitting}
                                // onClick={handleSubmit}
                                color='primary'
                                className='ms-3'
                                 onClick={handleSubmit}
                                // onChange={handleInputChange}
                                // disabled={true}
                            >
                                Save
                            </Button>
                            <Button
                                style={{ float: 'right' }}
                                // disabled={true}
                                // onClick={hanleEdit}
                                // onClick={() => handleReset(props)}
                                // toggle = {handleCancel}
                                onClick={handleClick}
                                // toggle = {true}
                                color='primary' >
                               Cancel
                            </Button>
                        </Col>

                                    </div>);
                            }}></Formik>

                </CardBody>

            </Card>
        </Container>
    </div>
  )
}

export default EditConfiguration
